export default "__VITE_ASSET__DTLz201t__"